export default __webpack_public_path__ + "static/media/not-found.a3dde4f4.svg";